export default [
    {
        path: 'dept/list',
        name: 'organization_dept_list',
        meta: { isCache: true, icon: 'md-medal', hideInMenu: false },
        component: () => import('@/views/organization/dept/dept-list.vue'),
    },
    {
        path: 'dept/add',
        name: 'organization_dept_add',
        meta: { isCache: true, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/organization/dept/dept-add.vue'),
    },
    {
        path: 'dept/edit/:id',
        name: 'organization_dept_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/organization/dept/dept-edit.vue'),
    },
    {
        path: 'dept/detail/:id',
        name: 'organization_dept_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/organization/dept/dept-detail.vue'),
    },
];
